<template>
  <div>
    <CommonBreadCrumbs :data="breadcrumbs"></CommonBreadCrumbs>
    <div>
      <NuxtLayout name="center">
        <div class="text-start sm:text-center mx-auto md:w-4/6">
          <h1 class="mb-8">{{ pageData.data.title }}</h1>
          <p class="flex justify-center sm:text-center w-full text-[19px]">
            {{ pageData.data.intro_text }}
          </p>
        </div>
      </NuxtLayout>

      <div class="bg-[#F0FBFB] md:my-20 mt-10 py-10">
        <NuxtLayout name="center">
          <FormContact />
        </NuxtLayout>
      </div>

      <NuxtLayout name="center">
        <div class="md:mx-10">
          <CommonLiveChatBlock></CommonLiveChatBlock>
        </div>
        <div class="flex flex-col md:flex-row pt-4 px-7 md:px-0 mb-24">
          <div class="flex md:basis-1/3 mb-14 md:mb-0">
            <component class="text-secondary mr-2 w-8 h-8 shrink-0" :is="MailIcon"></component>
            <div class="text-black-200 tracking-normal">
              <div>
                <h3 class="block tracking-normal">
                  <NuxtLink :to="'mailto:' + globalStore.siteSettings.email.support_email">
                    {{ globalStore.siteSettings.email.support_email }}
                  </NuxtLink>
                </h3>
                <p class="text-dark-blue text- font-heronew mt-1">
                  {{ $t("contact.info.livechatPrefix") }}
                  <NuxtLink @click="useShowChatWidget" to="#" class="text-secondary underline">
                    {{ $t("contact.info.livechat") }}
                  </NuxtLink>
                </p>
              </div>
            </div>
          </div>

          <div class="flex md:basis-1/3 md:justify-center mb-14 md:mb-0">
            <component class="text-secondary mr-2 w-8 h-8 shrink-0" :is="PhoneIcon"></component>
            <div class="text-black-200 tracking-normal">
              <div>
                <h3 class="block tracking-normal">
                  <NuxtLink
                    :to="
                      'tel:' +
                      globalStore.sitePrimaryPhoneNumber.country_code +
                      globalStore.sitePrimaryPhoneNumber.call_to_action_number
                    "
                  >
                    {{ globalStore.siteSettings.primary_phone_number.display_number }}
                  </NuxtLink>
                </h3>
                <p class="text-dark-blue text- font-heronew mt-1">
                  {{ $t("contact.info.linesOpen") }}
                </p>
              </div>
            </div>
          </div>

          <div class="flex md:basis-1/3 md:justify-end">
            <component class="text-secondary mr-2 w-8 h-8 shrink-0" :is="LocationMarkerIcon"></component>
            <div class="text-black-200 tracking-normal">
              <div>
                <h3 class="block tracking-normal">
                  {{ $t("contact.info.headquarterTitle") }}
                </h3>
                <div class="text-dark-blue text- font-heronew mt-1 whitespace-pre-line">
                  {{ globalStore.siteSettings.main_address }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </NuxtLayout>
    </div>
  </div>
</template>

<script setup>
import { useGlobalStore } from "~/stores/global";
import { useShowChatWidget } from "@/utils/useTawkMessenger";
import { MailIcon, PhoneIcon, LocationMarkerIcon } from "@heroicons/vue/outline";

const globalStore = useGlobalStore();

const breadcrumbs = getBreadcrumbs("contact-us");

const { data: pageData } = await useContactUsDetail();

useMetaTitles(pageData.value.data, "contact-us");
</script>
